import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const BaseLink = styled(Link)`
  color: ${({ theme }) => theme.colors.link};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.link};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`

export default BaseLink



// WEBPACK FOOTER //
// ./src/components/base/Link/index.tsx